import { lazy } from "react";
const Home = lazy(() => import("../../../pages/Home"));
const Login = lazy(() => import("../../../pages/Auth/Login"));
const SignUp = lazy(() => import("../../../pages/Auth/SignUp"));
const About = lazy(() => import("../../../pages/AboutUs"));
const ForgetPassword = lazy(() => import("../../../pages/Auth/ForgetPassword"));
const ResetPassword = lazy(() => import("../../../pages/Auth/ResetPassword"));
const Contact = lazy(() => import("../../../pages/Contact"));
const PrivacyPolicy = lazy(() => import("../../../pages/PrivacyPolicy"));
const CookiesPolicy = lazy(() => import("../../../pages/CookiesPolicy"));
const HelpCenter=lazy(()=> import("../../../pages/HelpCenter"))
const TermsAndConditions = lazy(
  () => import("../../../pages/TermsAndConditions"),
);
const VerifyPay = lazy(() => import("../../../pages/VerifyPay"));

const CancelOrReportOrderGuestUser = lazy(
  () => import("../../../pages/CancelOrReportOrderGuestUser"),
);

const NotFoundPage = lazy(() => import("../../../pages/404"));

export const generalRoutes = [
  {
    index: true,
    element: <Home homeCSS={"bg-transparent absolute top-0 left-0 z-50"} />,
  },
  { path: "login", element: <Login /> },
  { path: "sign-up", element: <SignUp /> },
  { path: "about", element: <About /> },
  {path: "help", element: <HelpCenter/>},
  { path: "terms-conditions", element: <TermsAndConditions /> },
  { path: "contact", element: <Contact /> },
  { path: "privacy-policy", element: <PrivacyPolicy /> },
  { path: "cookies-policy", element: <CookiesPolicy /> },
  { path: "forget-password", element: <ForgetPassword /> },
  { path: "reset-password", element: <ResetPassword /> },
  { path: "verify-pay", element: <VerifyPay /> },
  {
    path: "manage-orders/:action/:orderId/:email",
    element: <CancelOrReportOrderGuestUser />,
  },

  // { path: "*", element: <NotFoundPage /> }, // 404 catch-all under Layout
];
